import { types } from '../../types';

const setGetShiftAction = (payload) => {
  return {
    type: types.cashier.SET_SHIFT,
    payload,
  }
}

export {
  setGetShiftAction as SetGetShiftAction
}